<template>
    <div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                <i class="fas fa-hourglass-half"></i>&nbsp;Waiting for seller to shipment.
            </p>
            <div class="card-body text-center">
                <p class="text-center aboutscroll">
                    After the shipment you can release payment. If you wish to dispute this transaction, please click on Open Dispute button below.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ShipPending"
    }
</script>

<style scoped>

</style>